import { useState, useEffect, useContext } from 'react';
import { DealerContext } from '../../context';

export default function useGeolocation(
  dealerSearchEnabled: boolean,
  dealerSearchGeolocationEnabled: boolean,
  autoConnectedUnsubscribed: boolean,
  isTierOneDomain: boolean,
  options?: any,
) {
  const { renderDealerContext } = useContext(DealerContext);
  const [loading, setLoading] = useState(true);
  const [geoError, setGeoError] = useState(null);
  const [data, setData] = useState({});

  useEffect(() => {
    const successHandler = (e: any) => {
      setLoading(false);
      setGeoError(null);
      setData(e.coords);
    };
    const errorHandler = (e: any) => {
      setGeoError(e);
      setLoading(false);
    };
    if (
      !renderDealerContext ||
      !dealerSearchEnabled ||
      !dealerSearchGeolocationEnabled ||
      autoConnectedUnsubscribed ||
      !isTierOneDomain
    ) {
      return;
    }
    navigator.geolocation.getCurrentPosition(successHandler, errorHandler, options);
    const id = navigator.geolocation.watchPosition(successHandler, errorHandler, options);
    return () => {
      navigator.geolocation.clearWatch(id);
    };
  }, [dealerSearchEnabled, dealerSearchGeolocationEnabled, autoConnectedUnsubscribed, options]);

  return { loading, geoError, data };
}
